import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import { GoogleMapService } from '../../../../../../app.common/modules/common/services/google-map.service';
import { NotificationService } from '../../../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../../../app.common/modules/common/services/popup.service';
import { IRetailerRootScope } from '../../../../core/models';
import { IStoreForShopingListItem } from '../../../models';
import { IVendor } from '../models/IVendor';
import { IVendorImageSize } from '../models/IVendorImageSize';
import { VendorsMockService } from '../vendors-mock.service';

class AddOrEditVendorItem implements ng.IController {

    public static $inject = [
        '$scope',
        '$uibModal',
        '$translate',
        'notificationService',
        'vendorsMockService',
        '$timeout',
        'googleMapService',
        '$rootScope',
        'popupService'
    ];

    public idParam: number;
    public waiting = false;
    public vendorEditorForm: ng.IFormController;
    public showVendorNameError: boolean = false;
    public isMapShown: boolean = true;
    public isMapReady: boolean = false;
    public modalInstance: ng.ui.bootstrap.IModalInstanceService = this as any;
    public vendor: IVendor = {
        ID: null,
        FirstName: null,
        LastName: null,
        UserName: null,
        ImageID: null,
        Age: null,
        Street: null,
        Password: null,
        Description: null,
        ShortDescription: null,
        PlacesID: null,
        Latitude: null,
        Longitude: null,
        Interviewer: {
            InterviewerName: null,
            InterviewerImg: null
        }
    };

    public maps = {
        optionsEdit: null,
        edit: null,
        markerEdit: null,
        infoWindow: null,
        defaultLatLng: { lat: 51.500152, lng: -0.126236 },
        loadedEdit: false,
        validDistance: 500,
        zoom: 16, // 100 m
    };

    public selectedAddress: IStoreForShopingListItem;
    public locations: IStoreForShopingListItem[];
    public fullAddress: string;
    public avatarUrl: string;

    private isNew: boolean;
    private isViewChanged: boolean = false;
    private country: number;
    private googleMaps = null;
    private resolve: {
        vendorId: number;
        places: IStoreForShopingListItem[];
    };

    private minImageSize: IVendorImageSize = {
        w: 210,
        h: 210
    };

    constructor(
        private $scope: angular.IScope,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private $translate: angular.translate.ITranslateService,
        private notificationService: NotificationService,
        private vendorsService: VendorsMockService,
        private $timeout: ng.ITimeoutService,
        private googleMapService: GoogleMapService,
        private $rootScope: IRetailerRootScope,
        private popupService: PopupService
    ) { }

    public async $onInit() {
        this.idParam = this.resolve.vendorId;
        this.locations = this.resolve.places;
        this.isNew = !this.idParam;
        this.country = this.$rootScope.userData.countryID;
        this.setDefaultMapLocation();
        if (!this.isNew) {
            await this.loadVendor();
            await this.getMapData();
            this.setAddImageWatcher();
        } else {
            await this.getMapData();
        }
        this.setViewWatcher();
    }

    public closeDialog() {
        this.modalInstance.close({ $value: false });
    }

    public setDefaultUsername() {
        this.vendor.UserName = [this.vendor.FirstName, this.vendor.LastName].join('');
    }

    public async setSelectedVendorLocation() {
        this.vendor.PlacesID = [this.selectedAddress.ID];
        if (this.isViewChanged && this.vendor.Latitude && this.vendor.Longitude) {
            this.vendor.Latitude = null;
            this.vendor.Longitude = null;
            this.fullAddress = null;
            await this.getMapData();
            this.isViewChanged = false;
        } else if (this.isViewChanged && !this.vendor.Latitude && !this.vendor.Longitude && this.fullAddress) {
            this.fullAddress = null;
            this.isViewChanged = false;
        }
    }

    public isFullAddressFiledValid() {
        if (this.isMapShown) {
            return Boolean(this.fullAddress && this.vendor.Latitude && this.vendor.Longitude);
        } else {
            return Boolean(this.vendor.PlacesID);
        }
    }

    public mapdragstart = () => {
        this.maps.edit.setOptions({ draggingCursor: 'move' });
    }

    public mapdragend = () => {
        this.maps.edit.setOptions({ draggingCursor: 'default' });
    }

    public setMarker = ($event, $params) => {
        if (!this.maps.edit) {
            this.resizeGoogleMaps();
            return;
        }
        if (this.maps.markerEdit) {
            this.maps.markerEdit.setMap(null);
        }

        this.maps.markerEdit = new this.googleMaps.Marker({
            map: this.maps.edit,
            position: $params[0].latLng,
            title: this.fullAddress,
            draggable: true
        });
        this.maps.edit.setCenter($params[0].latLng);
    }

    public maploaded = () => {
        if (this.isMapShown && !this.maps.loadedEdit) {
            this.maps.loadedEdit = true;
            this.refreshGoogleMaps();
        }
    }

    public openMarkerInfo = (map, marker) => {
        new this.googleMaps.Geocoder().geocode(
            { location: marker.getPosition() },
            (results, status) => {
                if (status === this.googleMaps.GeocoderStatus.OK) {
                    this.maps.infoWindow.setContent(
                        results[0].formatted_address
                    );
                    this.maps.infoWindow.open(map, marker);
                }
            }
        );
    }

    public getLocationFromAddress = ($event) => {
        if (this.isViewChanged && this.vendor.PlacesID) {
            this.vendor.PlacesID = null;
            this.selectedAddress = null;
            this.isViewChanged = false;
        }
        const currentSelectedAddress = this.fullAddress;
        const geocoder = new this.googleMaps.Geocoder();
        geocoder.geocode(
            {
                address: currentSelectedAddress
            },
            (results, status) => {
                if (status === this.googleMaps.GeocoderStatus.OK) {
                    this.setMarker(null, [
                        { latLng: results[0].geometry.location }
                    ]);
                    this.maps.edit.setZoom(this.maps.zoom);
                    const position = this.maps.markerEdit.getPosition();
                    this.vendor.Latitude = position.lat();
                    this.vendor.Longitude = position.lng();
                    this.setGoogleMaps(this.vendor.Latitude, this.vendor.Longitude);
                    console.log(this.vendor);
                } else {
                    this.popupService
                        .alert({
                            title: this.$translate.instant(
                                'cant_determine_location'
                            ),
                            content: `<p>${this.$translate.instant(
                                'cant_determine_location_description'
                            )}</p>`,
                        })
                        .then(() => {
                            return;
                        })
                        .catch(() => {
                            return;
                        });
                }
            }
        );
        $event.preventDefault();
        $event.stopPropagation();
    }

    public async saveVendorForm() {
        console.log(this.vendor);

        this.notificationService.showWaitingMessage();
        this.waiting = true;
        try {
            if (!this.vendor.PlacesID && this.vendor.Longitude && this.vendor.Latitude) {
                const model = {
                    address: this.fullAddress,
                    name: this.vendor.Street,
                    latitude: this.vendor.Latitude,
                    longitude: this.vendor.Longitude,
                };
                // this.vendor.PlacesID = await createVendorLocation(model)
            }

            await this.vendorsService.createOrUpdateVendor(this.vendor, this.idParam ? this.idParam : null);
            this.notificationService.clearAll();
            this.notificationService.showSuccessMessage();
            this.modalInstance.close({ $value: true });
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        finally {
            this.waiting = false;
        }
    }

    public async addImage() {
        try {
            const imageID = await this.$uibModal.open({
                component: 'jispPayAvatar',
                resolve: {
                    avatarId: () => this.vendor.ImageID,
                    title: () => this.$translate.instant('vendor_photo'),
                    sizeText: () =>
                    this.$translate.instant('store_photo_min_size_hint', {width: 210, height: 210}),
                    getUrl: () =>
                        this.vendor.ImageID == null ||
                        this.vendorsService.getVendorImageUrl(this.vendor.ImageID),
                    saveUrl: () => this.vendorsService.saveVendorImageUrl(),
                    imageSize: () => this.minImageSize
                },
                backdrop: 'static'
            }).result;
            if (imageID) {
                this.vendor.ImageID = imageID;
                this.avatarUrl = this.vendorsService.getVendorImageUrl(this.vendor.ImageID);
            }
        } catch (error) {
            return;
        }
    }

    private async loadVendor() {
        this.notificationService.showWaitingMessage();
        this.waiting = true;
        try {
            this.vendor = await this.vendorsService.getVendor(this.idParam);
            this.selectedAddress = this.locations.find((location) => location.ID === this.vendor.PlacesID[0]);
            this.isMapShown = Boolean(this.vendor.Latitude && this.vendor.Longitude);
            this.fullAddress = this.isMapShown ? this.selectedAddress.info : null;
            this.avatarUrl = this.vendor.ImageID ? this.vendorsService.getVendorImageUrl(this.vendor.ImageID) : null;
            this.notificationService.clearAll();
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }

    private setAddImageWatcher() {
        this.$scope.$watch(() => this.vendor.ImageID, (newValue, oldValue) => {
            if (newValue !== oldValue) {
                this.vendorEditorForm.$setDirty();
            }
        });
    }

    private setViewWatcher() {
        this.$scope.$watch(() => this.isMapShown, (newValue, oldValue) => {
            if (newValue !== oldValue && !this.isViewChanged) {
                this.isViewChanged = true;
            } else if (newValue !== oldValue && newValue && this.isViewChanged) {
                if (this.vendor.Longitude && this.vendor.Latitude) {
                    this.refreshGoogleMaps();
                }
            }
        });
    }

    private setDefaultMapLocation() {
        // 2 = Norway, 1 = UK, 3 = USA, 4 = Ireland
        switch (this.country) {
            case 2: {
                this.maps.defaultLatLng = { lat: 59.9145019, lng: 10.7566006 };
                break;
            }
            case 1: {
                this.maps.defaultLatLng = { lat: 51.500152, lng: -0.126236 };
                break;
            }
            case 3: {
                this.maps.defaultLatLng = { lat: 40.7127, lng: -74.0059 };
                break;
            }
            case 4: {
                this.maps.defaultLatLng = { lat: 53.342754, lng: -6.271849 };
                break;
            }
        }
    }

    private resizeGoogleMaps = () => {
        this.$timeout(() => {
            if (this.isMapShown && !this.maps.edit) {
                this.googleMaps.event.trigger(this.maps.edit, 'resize');
            }
        }, 300)
            .finally(() => this.isMapReady = true);
    }

    private refreshGoogleMaps = () => {
        if (this.isMapShown) {
            if (!this.vendor.Longitude && !this.vendor.Latitude) {
                this.maps.edit.setCenter(this.maps.optionsEdit.center);
            } else {
                if (this.maps.markerEdit !== null) {
                    this.maps.markerEdit.setMap(null);
                }
                this.maps.markerEdit = new this.googleMaps.Marker({
                    map: this.maps.edit,
                    position: this.maps.optionsEdit.center,
                    title: this.fullAddress,
                    draggable: true
                });
                this.maps.edit.setCenter(this.maps.optionsEdit.center);
            }
        }
    }

    private async getMapData() {
        this.googleMaps = await this.googleMapService.getGoogleMaps();
        console.log(this.vendor.Latitude, this.vendor.Longitude);
        this.setGoogleMaps(this.vendor.Latitude, this.vendor.Longitude);
    }

    private setGoogleMaps(lat: number, lng: number) {
        let position;
        if (!lat || !lng) {
            position = new this.googleMaps.LatLng(
                this.maps.defaultLatLng.lat,
                this.maps.defaultLatLng.lng
            );
        } else {
            position = new this.googleMaps.LatLng(lat, lng);
        }

        this.maps.optionsEdit = {
            center: position,
            zoom: this.maps.zoom,
            mapTypeId: this.googleMaps.MapTypeId.ROADMAP,
            zoomControl: true,
            scrollwheel: false,
            disableDefaultUI: true,
            disableDoubleClickZoom: false,
            scaleControl: true,
            draggableCursor: 'default',
            draggingCursor: 'default'
        };

        this.maps.infoWindow = new this.googleMaps.InfoWindow();
        this.resizeGoogleMaps();
    }
}

angular.module('naut').component('addOrEditVendorItem', {
    template: require('./add-or-edit-vendor-item.component.html'),
    controller: AddOrEditVendorItem,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/jispPay/components/vendors/add-or-edit-vendor-item/add-or-edit-vendor-item.component.ts